import { useRef } from 'react'
import { toast } from 'react-toastify'
import { addDoc, collection, serverTimestamp } from 'firebase/firestore'
import { db } from '../firebase.config'
import getTime from '../assets/getTime'

function InquiryForm({ propertyName, listingId }) {
  const nameInput = useRef(null)
  const emailInput = useRef(null)
  const phoneInput = useRef(null)
  const messageInput = useRef(null)

  const checkInputandSubmitHandler = async (event) => {
    event.preventDefault()
    const name = nameInput.current.value
    const email = emailInput.current.value
    const phoneNo = phoneInput.current.value
    const message = messageInput.current.value

    await addDoc(collection(db, 'inquiries'), {
      name,
      email,
      phoneNo,
      message,
      listingId,
      agent: null,
      timestamp: serverTimestamp(),
    })
    event.target.reset()
    toast.success('Your Inquiry has been sent! You will be contacted soon')
  }

  return (
    <div className="inquiry">
      <p className="listingLocationTitle">Contact Us</p>
      <div>
        <form
          className="inquiryForm"
          action="submit"
          onSubmit={checkInputandSubmitHandler}
        >
          <div className="inputsection">
            <label htmlFor="">Name</label>
            <input
              required
              ref={nameInput}
              className="input"
              type="text"
              placeholder="Name"
            />
          </div>
          <div className="inputsection">
            <label htmlFor="">Email</label>
            <input
              required
              ref={emailInput}
              className="input"
              type="email"
              placeholder="eg: youremail@mail.com"
            />
          </div>
          <div className="inputsection">
            <label htmlFor="">Phone</label>
            <input
              required
              ref={phoneInput}
              className="input"
              type="text"
              placeholder="eg: +971502849458"
              pattern="^(?:\+971|00971|0)?(?:50|51|52|55|56|2|3|4|6|7|9)\d{7}$"
            />
          </div>
          <div className="inputsection">
            <label htmlFor="">Message</label>
            <textarea
              required
              ref={messageInput}
              name=""
              id=""
              className="textarea"
              defaultValue={`I am interested in obtaining more information about the property '${propertyName}'. Please contact me.`}
            />
          </div>
          <div>
            <button className="inquiryButton">Send Inquiry</button>
          </div>
        </form>
      </div>
    </div>
  )
}

export default InquiryForm
